import React from "react";

import ArticleLayout from "../../../../components/v2/Noticias/ArticleLayout";

export default function TransacaoHotelaria() {
  return (
    <ArticleLayout slug="transacao-hotelaria">
      <p><strong>As concessões do Município de Fortaleza</strong> envolverão créditos tributários de IPTU e de ISSQN inscritos em Dívida Ativa e <strong>poderão reduzir em até 100%</strong> o valor das multas moratórias, dos juros de mora, da correção monetária e dos honorários advocatícios, bem como, preveem um <strong>parcelamento em até 60 (sessenta) meses, com parcelas mensais, iguais e sucessivas;</strong> condicionado a <strong>parcela mínima de R$350,00</strong> (trezentos e cinquenta reais).</p>
      <p>O cumprimento da contrapartida considerará os seguintes limites com relação ao valor a ser investido pelo devedor:</p>
      <ul>
        <li>I- 80% dos gastos realizados com requalificação da infraestrutura ou com a modernização das instalações e dos serviços de hotelaria;</li>
        <li>II- 20% dos gastos realizados com a capacitação e o treinamento do quadro de funcionários do empreendimento hoteleiro.</li>
      </ul>
      <p><strong>O interessado deverá preencher o Requerimento de Adesão à Transação Tributária </strong> a ser formalizado pelo responsável legal do CNPJ, acompanhado dos documentos listados no Edital de Transação Tributária por Adesão nº01/2022, item 4.3.</p>
      <h2 className="pgm-title-large">Contato</h2>
      <p>
        Atendimento de Dívida Ativa <br /> (Procuradoria da Fazenda)
      </p>
      <ul>
        <li>(85) 98419-2045</li>
        <li>(85) 98419-2042</li>
      </ul>
    </ArticleLayout>
  );
}
